import React from "react";
import style from "./style.module.css";
import AvatarsImage from "../../../../assets/images/png/avatars.webp";
import * as Animate from "react-reveal";

const StatSection = () => {
  return (
    <section
      className={`relative pt-24 md:pt-32 lg:pt-40 pb-32 lg:pb-40 ${style.bg}`}
    >
      <div className="relative container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-0 items-center">
          <div className="w-full lg:w-9/12 mx-auto">
            <Animate.Fade bottom>
              <h3 className="block lg:hidden mb-10 mx-auto font-semibold text-3xl md:text-3xl lg:text-4xl xl:text-4xl xl:leading-snug text-primary font-mono">
                Our Goal
              </h3>
              <div className="w-4/12 mb-2">
                <img src={AvatarsImage} alt="" />
              </div>
              <h3 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold font-mono text-utiva-green">
                50,000
              </h3>
              <p className="pt-2 text-lg lg:text-xl">Young Africans</p>
            </Animate.Fade>
          </div>
          <div className="w-full lg:w-10/12 mx-auto">
            <Animate.Fade bottom>
              <h3 className="hidden lg:block mx-auto font-semibold text-3xl md:text-3xl lg:text-4xl xl:text-4xl xl:leading-snug text-primary">
                About The Scholarship
              </h3>
              <p className="pt-4 lg:pt-6 text-base lg:text-lg lg:leading-9">
                Binance Charity, the philanthropic arm of Binance, the world’s
                leading cryptocurrency and blockchain infrastructure provider
                has partnered with Utiva to educate 50,000 Africans across
                different countries and provide scholarships for 1,000 Africans
                in a 1-year intensive skill training program to learn any
                premium tech skill and also get started in the Web3 Space.
              </p>
            </Animate.Fade>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatSection;
